// DB 함수 public.normalize_item_name(supabase/migrations/20260711150000_inventory_foundation.sql)과
// byte-동일 계약 — 한쪽을 바꾸면 반드시 다른 쪽도 함께 바꿀 것.
// DB 구현: lower(regexp_replace(normalize(btrim(coalesce(s,'')), NFC), '\s', '', 'g'))
//
// ★ /\s/g 사용 금지: JS 정규식 \s는 NBSP(U+00A0)·U+2028 등 유니코드 공백까지 제거하지만
//   Postgres \s([[:space:]])는 ASCII 공백만 제거한다 — NBSP가 포함된 상품명이면 두 구현의
//   norm_name이 갈라진다(norm drift). ASCII 전용 문자 클래스 [ \t\n\r\f\v]가 정답.
// ★ btrim(공백 전용 trim)은 생략해도 등가: DB의 btrim은 앞뒤 공백만 제거하는데, 뒤이은 전역
//   공백 제거(regexp_replace ... 'g')가 문자열 내부 공백까지 전부 지우므로 앞뒤 공백도 그 안에
//   흡수된다. 즉 btrim 유무와 무관하게 최종 결과는 같다 — 이 TS 구현은 btrim 단계를 생략한다.
export function normalizeItemName(s: string | null | undefined): string {
  return (s ?? '').normalize('NFC').replace(/[ \t\n\r\f\v]/g, '').toLowerCase()
}
